const t = (o) => o ? { maxWidth: o, width: "100%" } : {};
export {
  t as composePopoverWidth
};
